"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.experimentStatusEnumReverse = exports.experimentStatusEnum = void 0;
const experimentStatusEnum = {
  DRAFT: 1,
  TESTING: 2,
  RUNNING: 3,
  COMPLETED: 4,
  CANCELLED: 5,
  DELETED: 6,
  CLONED: 7,
  APPROVED: 8,
  OBSERVATIONAL: 9
};
exports.experimentStatusEnum = experimentStatusEnum;
const experimentStatusEnumReverse = {
  1: 'Draft',
  2: 'Testing',
  3: 'Running',
  4: 'Completed',
  5: 'Cancelled',
  6: 'Deleted',
  7: 'Cloned',
  8: 'Approved',
  9: 'Observational'
};
exports.experimentStatusEnumReverse = experimentStatusEnumReverse;